module.exports = __webpack_public_path__ + "static/img/ksznn_3d_s.6c16bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/ksznn_3d_s.png
// module id = ps3f
// module chunks = 0